module.exports = __webpack_public_path__ + "img/tramites_asignados.006b9f95.png";